import React, { Component } from "react";
import moment from "moment";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { withRouter } from "../../../withRouter";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import {
  FaCcVisa,
  FaCcMastercard,
  FaCcAmex,
  FaCcDiscover,
} from "react-icons/fa";
import { MdCreditCard } from "react-icons/md";
import Utils from "../../../provider/Utils";
import PtsAlert from "../ptsAlert/PtsAlert";
import Billing from "../billing/Billing";
import CreditCardForm from "./CreditCardForm";
import { Elements, ElementsConsumer } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import ActiveMenuAction from "../../../redux/activeMenu/ActiveMenuAction";

const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
);

class PurchasePlan extends Component {
  header = store.getState().header.header;
  menus = store.getState().appUserData.appUserData.appuser?.profile?.menus;

  constructor(props) {
    super(props);
    let planId = props.planId;
    let subscriptionId = props.subscriptionId;
    let pageId = props.pageId;
    if (props.state) {
      planId = props.state.planId;
      subscriptionId = props.state.subscriptionId;
    }
    if (null !== planId && planId > 0) {
      this.getPlanDetails(planId);
    }
    this.state = {
      planId: planId,
      subscriptionId: subscriptionId,
      pageId: pageId,
      eventplan: null,
      cardType: "",
      cardName: "",
      firstName: "",
      lastName: "",
      cardId: "",
      cardNumber: "",
      cardMonth: "",
      cardYear: "",
      expiryDate: "",
      cvvCode: "",
      render: false,
      processing: false,
      error: null,
      success: false,
    };
  }

  getPlanDetails(planId) {
    const postObject = {
      header: this.header,
      plan: {
        id: planId,
      },
    };
    FetchServerData.callPostService("/planms/get", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let planDetails = output.data.plan;
          this.setState({
            eventplan: planDetails,
            render: true,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  handleCardTypeChange(e) {
    const { value } = e.target;
    this.setState({ cardType: value });
  }
  handleCardNumberChange(e) {
    let number = Utils.formatCardNumber(e.target.value);
    this.setState({ cardNumber: number });
  }
  handleCardNameChange(e) {
    this.setState({ cardName: e.target.value });
  }
  handleFirstNameChange(e) {
    this.setState({ firstName: e.target.value });
  }
  handleLastNameChange(e) {
    this.setState({ lastName: e.target.value });
  }

  handleCardMonthChange(date) {
    let newDate = moment(date).format("MM");
    this.setState({ cardMonth: newDate });
  }
  handleCardYearChange(date) {
    let newDate = moment(date).format("yyyy");
    this.setState({ cardYear: newDate });
  }
  handleCvvCodeChange(e) {
    this.setState({ cvvCode: e.target.value });
  }

  handleAddressLine1Change(e) {
    this.setState({ addressLine1: e.target.value });
  }
  handleAddressLine2Change(e) {
    this.setState({ addressLine2: e.target.value });
  }
  handleCityChange(e) {
    this.setState({ city: e.target.value });
  }

  handleStateChange(selectedState) {
    this.setState({ state: selectedState });
  }
  handlePinCodeChange(e) {
    this.setState({ zipCode: e.target.value });
  }

  // handleExpiryDateChange(e) {
  //   let date = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
  //   let month = "";
  //   let year = "";
  //   if (date.length > 6) date = date.slice(0, 6); // Limit to 6 digits

  //   // Format as MM/YYYY
  //   if (date.length >= 3) {
  //     date = `${date.slice(0, 2)}/${date.slice(2)}`;
  //     month = date.slice(0, 2);
  //     year = date.slice(3);
  //   }

  //   this.setState({
  //     expiryDate: date,
  //     cardMonth: month,
  //     cardYear: year,
  //   });
  // }
  handleExpiryDateChange(e) {
    let digits = e.target.value.replace(/[^0-9]/g, "");
    if (digits.length > 4) digits = digits.slice(0, 4);

    let formatted = digits;
    let month = "",
      year = "";

    if (digits.length > 2) {
      month = digits.slice(0, 2);
      year = digits.slice(2);
      formatted = month + "/" + year;
    }

    this.setState({
      expiryDate: formatted, // in MM/YY
      cardMonth: month,
      cardYear: year,
    });
  }
  getIcon = () => {
    switch (this.state.cardType) {
      case "visa":
        return <FaCcVisa size={32} color="#1a1f71" />;
      case "master card":
        return <FaCcMastercard size={32} color="#eb001b" />;
      case "american express":
        return <FaCcAmex size={32} color="#2e77bb" />;
      case "discover":
        return <FaCcDiscover size={32} color="#f76f02" />;
      default:
        return <MdCreditCard size={32} color="#aaa" />;
    }
  };

  purchasePlanToBackend() {
    if (this.state.pageId === "UpgradePlan") {
      this.updatePurchasePlanToBackend();
    } else {
      this.purchaseSubscriptionsPlanToBackend();
    }
  }

  purchaseSubscriptionsPlanToBackend() {
    const postObject = {
      header: this.header,
      plan: {
        id: this.state.planId,
      },
      //   event: {
      //     id: this.state.eventId,
      //   },
      creditCard: {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        type: this.state.cardType,
        number: this.state.cardNumber?.replace(/\s+/g, ""),
        month: this.state.cardMonth,
        year: this.state.cardYear,
        cvv: this.state.cvvCode,
      },
    };
    FetchServerData.callPostService(
      "/customerOrderms/purchasePlan",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.setState({
          action: "billing",
        });
      } else {
      }
    });
  }

  UpgradePlanToBackend(data) {
    const postObject = {
      header: this.header,
      subscription: { id: this.state.subscriptionId },
      card: { id: data.creditCard?.id },
      plan: { id: this.state.eventplan?.id },
    };
    FetchServerData.callPostService(
      "/paymentms/upgradeSubscription",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        store.dispatch(
          ActiveMenuAction.setActiveMenu(Utils.getArrayElement(this.menus, 0)?.pageid)
        );

        for (let i = 0; i < this.menus?.length; i++) {
          const menu = this.menus[i];
          if (menu?.isactive) {
            this.props.navigate(menu?.pageid);
            break;
          }
        }
      }
    });
  }

  viewCancel() {
    this.setState({
      action: "billing",
    });
  }

  onSuccessPayment() {
    this.setState({ action: "billing" });
  }

  render() {
    if (this.state.action === "billing") {
      return <Billing action="view" />;
    } else {
      if (this.state.render === false) {
        return <div />;
      } else {
        return (
          <>
            <div className="row">
              <div
                md={12}
                style={{
                  width: "100%",
                  color: "#000",
                  fontSize: "small",
                }}
              >
                <div className="col-md-12">
                  <div
                    className="card "
                    id="giveBeeCard"
                    style={{ borderRadius: "0px 0px 0.5rem 0.5rem" }}
                  >
                    <div className="card-body">
                      <div class="container">
                        <div class="row  justify-content-around">
                          <div className="col-md-4 align-self-center">
                            <div className="row d-flex align-item-stretch justify-content-center">
                              <div className="col-md-9">
                                <div
                                  className="row d-flex"
                                  style={{
                                    height: "100%",
                                  }}
                                >
                                  <div className="col-md-12">
                                    <div
                                      className="box"
                                      data-aos="zoom-in"
                                      data-aos-delay={100}
                                      style={{
                                        padding: "0em",
                                        position: "relative",
                                        height: "100%",
                                      }}
                                      id="regPlanBox"
                                    >
                                      <div
                                        class="regplan-inner plan_card plan_card_bottom"
                                        style={{
                                          height: "100%",
                                        }}
                                      >
                                        <div
                                          class="entry-title plan_card"
                                          style={{
                                            background:
                                              this.state.eventplan
                                                ?.colorSecondary,
                                          }}
                                        >
                                          <h3
                                            class="plan_card"
                                            style={{
                                              padding: "7px",
                                              color: "#fff",
                                              background:
                                                this.state.eventplan
                                                  ?.colorPrimary,
                                            }}
                                          >
                                            {this.state.eventplan?.name}
                                          </h3>
                                          <div
                                            class="price"
                                            style={{
                                              background:
                                                this.state.eventplan
                                                  ?.colorPrimary,
                                            }}
                                          >
                                            <span
                                              style={{
                                                left: "20px",
                                              }}
                                            >
                                              {`$${this.state.eventplan?.price}`}
                                            </span>
                                          </div>
                                        </div>
                                        <div class="entry-content mb-4">
                                          <ul>
                                            {this.state.eventplan?.planItems.map(
                                              (planItems, index) => (
                                                <li
                                                  style={{
                                                    padding: "0.2em",
                                                  }}
                                                >
                                                  {planItems.name}
                                                </li>
                                              )
                                            )}
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <Elements stripe={stripePromise}>
                              <ElementsConsumer>
                                {({ stripe, elements }) => (
                                  <CreditCardForm
                                    stripe={stripe}
                                    elements={elements}
                                    eventplan={this.state.eventplan}
                                    onSuccessPayment={this.onSuccessPayment.bind(
                                      this
                                    )}
                                    onUpgradePlan={this.UpgradePlanToBackend.bind(
                                      this
                                    )}
                                    subscriptionId={this.state.subscriptionId}
                                    pageId={this.state.pageId}
                                    action="list"
                                  />
                                )}
                              </ElementsConsumer>
                            </Elements>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12">
                <div style={{ float: "left" }}>
                  <Button
                    type="submit"
                    variant="contained"
                    size="small"
                    style={{
                      background: "#6A7B8E",
                      color: "#fff",
                      textTransform: "capitalize",
                    }}
                    startIcon={<ArrowBackIcon />}
                    onClick={(e) => this.viewCancel(e)}
                  >
                    Back
                  </Button>
                </div>
              </div>
            </div>
          </>
        );
      }
    }
  }
}
export default withRouter(PurchasePlan);
